import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' }
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('merchant_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('merchant_token');
      localStorage.removeItem('merchant_user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  register: (data) => api.post('/auth/register', data),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (data) => api.post('/auth/reset-password', data),
  me: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.post('/auth/change-password', data),
};

export const dashboardAPI = {
  stats: () => api.get('/dashboard/stats'),
  recentPayments: () => api.get('/dashboard/recent-payments'),
  chartData: (period) => api.get(`/dashboard/chart?period=${period}`),
};

export const paymentsAPI = {
  list: (params) => api.get('/payments', { params }),
  get: (id) => api.get(`/payments/${id}`),
  refund: (id, data) => api.post(`/payments/${id}/refund`, data),
  export: (params) => api.get('/payments/export', { params, responseType: 'blob' }),
};

export const payoutsAPI = {
  balance: () => api.get('/payouts/balance'),
  list: (params) => api.get('/payouts', { params }),
  request: (data) => api.post('/payouts/request', data),
};

export const settingsAPI = {
  getKeys: () => api.get('/settings/keys'),
  regenerateKey: (type) => api.post(`/settings/keys/regenerate`, { type }),
  getWebhooks: () => api.get('/settings/webhooks'),
  updateWebhooks: (data) => api.put('/settings/webhooks', data),
  getNotifications: () => api.get('/settings/notifications'),
  updateNotifications: (data) => api.put('/settings/notifications', data),
};

export const teamAPI = {
  list: () => api.get('/team'),
  invite: (data) => api.post('/team/invite', data),
  updateRole: (id, role) => api.put(`/team/${id}/role`, { role }),
  remove: (id) => api.delete(`/team/${id}`),
};

export const analyticsAPI = {
  overview: (params) => api.get('/analytics/overview', { params }),
  conversion: (params) => api.get('/analytics/conversion', { params }),
  declineReasons: (params) => api.get('/analytics/decline-reasons', { params }),
};

export default api;
